import { COLORS } from "common/colors";
import { ERRORS, LABELS, SUCCESS, TITLES, WARNINGS } from "common/lables";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import React, { useEffect, useState } from "react";
import { GEO_APIs } from "../../../apihandlers/geography";
import { COMMON_JS } from "common/scripts";
import { DEFAULTS, NOTIFY } from "common/config";
import { LoadScript } from "@react-google-maps/api";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

const Country = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);

  const [columns, setColumns] = useState<any>([
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "countryName",
      name: LABELS.COUNTRY_NAME,
      type: "number",
      width: "45%",
      editable: false,
      sortable: true,
      align: "center",
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE_STATUS,
      type: "number",
      width: "45%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ]);
  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };

    GEO_APIs.getCountries(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          //   if (list[i]["loadingOnlyStatus"]) {
          //     list[i]["loadingOnlyStatus"] = "Yes";
          //   } else {
          //     list[i]["loadingOnlyStatus"] = "No";
          //   }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log("SELECTED ROW", selectedRow);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
    console.log("selected row", selectedRow);
  };
  const mangeCountry = () => {
    const countryName = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";
    const args = {
      id: selectedRow.id || -1,
      countryName,
      countryCode: " ",
      countryDialCode: " ",
      activeStatus,
    };
    if (!countryName) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    console.log("SELECTED ROW", selectedRow);
    setIsSubmit(true);

    GEO_APIs.manageCountry(args).then((res) => {
      setIsSubmit(false);

      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };
  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.COUNTRY}</li>
        </ul>
        <h4>{TITLES.COUNTRY}</h4>
        {/* <p>{SUB_TITLES.USERS}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={TITLES.COUNTRY}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.COUNTRY + ": " + selectedRow.id
              : "Add " + TITLES.COUNTRY
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup ">
              <TxtRow
                id={"name"}
                label={LABELS.NAME}
                defaultValue={selectedRow.id ? selectedRow.countryName : ""}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup submitBtnWrapper">
              <div className="width45 flexRowJustify">
                <Btn
                  text={LABELS.SAVE}
                  onClick={mangeCountry}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.DIM_DARK_GRAY}
                  onClick={() => setManageDialog(false)}
                  loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(Country);
